import React, { Fragment, useEffect, useState } from "react"

import { Field, useFormikContext } from "formik"
import validator from "validator"
import { MAX_INPUT_LIMIT } from "../../../../utilities/constants.js"
import {
  FIELD_TYPES,
  OTHER_OPTION_PLACEHOLDER_VALUE,
  OTHER_OPTION_VALIDATION_ERROR_MESSAGE,
  validTextEntryMatchRegex,
  validTextErrorMessage,
} from "../dynamic-form.constants"
import { getInNested } from "../dynamic-form.helper"
import InputText from "./input-text"

function InputRadio(props) {
  const { id, label, name, rows, optionData, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { values, touched, errors } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  const [optionList, setOptionList] = useState([])

  useEffect(() => {
    const tempOptionList = [...optionData]
    if (fieldData && optionData && Array.isArray(optionData)) {
      if (
        fieldData.type === FIELD_TYPES.OPTIONS_WITH_STRING_OTHER &&
        !optionData.find((option) => option.display?.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase())
      ) {
        tempOptionList.push({
          display: OTHER_OPTION_PLACEHOLDER_VALUE,
          value: OTHER_OPTION_PLACEHOLDER_VALUE,
        })
      }
      setOptionList(tempOptionList)
    }
  }, [optionData, fieldData])

  const hasOtherOption = () => {
    return optionList.find((option) => option.display?.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase())
  }

  const getOtherOptionView = ({ propName, rows }) => {
    const otherOptionTextName = `other_${propName}`
    const fieldValues = getInNested(values, name, isNestedFieldName)
    if (fieldValues && typeof fieldValues === "string" && fieldValues.toLowerCase() === OTHER_OPTION_PLACEHOLDER_VALUE.toLowerCase()) {
      let error_message = OTHER_OPTION_VALIDATION_ERROR_MESSAGE
      if (!values[otherOptionTextName]) {
        errors[otherOptionTextName] = error_message
      } else if (!validator.matches(values[otherOptionTextName], validTextEntryMatchRegex)) {
        error_message = validTextErrorMessage
        errors[otherOptionTextName] = error_message
      } else if (!validator.isLength(values[otherOptionTextName], { max: MAX_INPUT_LIMIT })) {
        error_message = `Value must be ${MAX_INPUT_LIMIT} characters or less.`
        errors[otherOptionTextName] = error_message
      } else {
        delete errors[otherOptionTextName]
      }
      return (
        <InputText
          id={`other-${id}`}
          label="Other"
          name={otherOptionTextName}
          rows={rows}
          placeholder="Enter a value"
          errorMessage={error_message}
          isRequired={true}
        ></InputText>
      )
    } else {
      values[otherOptionTextName] = ""
      delete errors[otherOptionTextName]
      return null
    }
  }
  return (
    <Fragment>
      <div className="custom-form-block">
        <fieldset disabled={fieldData.enabled === false}>
          <label htmlFor={id} className="form-label mt-2">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="c-radio-groups" role="group">
            {optionList &&
              Array.isArray(optionList) &&
              optionList.map((option, option_index) => (
                <div className="form-check form-check-inline" key={`${id}-option-${option_index}`}>
                  {/* <pre>{JSON.stringify()}</pre> */}
                  <Field
                    type="radio"
                    name={normalizedNameKey}
                    id={`option-${id}-${option_index}`}
                    className={`form-check-input`}
                    checked={getInNested(values, name, isNestedFieldName) === option.value ? true : false}
                    value={option.value}
                    {...otherProps}
                  ></Field>
                  <label htmlFor={`option-${id}-${option_index}`} className="form-check-label">
                    {option.display}
                  </label>
                </div>
              ))}
          </div>
          <div className="invalid-feedback">
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </fieldset>
      </div>
      <fieldset disabled={fieldData.enabled === false}>
        {hasOtherOption() && (
          <div className="col-12" style={{ paddingRight: "12px" }}>
            {getOtherOptionView({ propName: name, rows })}
          </div>
        )}
      </fieldset>
    </Fragment>
  )
}

InputRadio.propTypes = {}

export default InputRadio
